import React from "react";
import { notification } from "antd";
import { CheckCircleFilled, CloseCircleFilled } from "@ant-design/icons";
import "../../styles/pages/ouber.scss";

// Reusable toast notification configuration using Ant Design's notification.
export const showSuccessToast = (message, description = "") => {
  notification.success({
    message,
    description,
    icon: <CheckCircleFilled style={{ color: "#52c41a" }} />,
    className: "ouber-toast-success",
    placement: "topRight",
    duration: 3,
  });
};

export const showErrorToast = (message, description = "") => {
  notification.error({
    message,
    description,
    icon: <CloseCircleFilled style={{ color: "#ff4d4f" }} />,
    className: "ouber-toast-error",
    placement: "topRight",
    duration: 5,
  });
};

const ToastNotification = () => {
  return null;
};

export default ToastNotification;
